export const intranetService = `/v1/central-service/`;
export const REST_URLS = {
  INTRANET_LOGIN: `${intranetService}auth/login-with-token`,
  REFRESH_TOKEN: `${intranetService}auth/refresh-tokens-app`,
  LOGIN: `${intranetService}auth/login`,
  REFRESH_TOKEN_INTRANET: `${intranetService}auth/refresh-tokens`,
  FORGOT_PASSWORD: `${intranetService}auth/forgot-password`,
  RESET_PASSWORD: `${intranetService}auth/reset-password`,
};

export const HOSTNAME = "https://api.mysubway.in";
export const INTRANETHOSTNAME = `https://api.mysubway.in`;
export const INVOICE_TRACKING_HOSTNAME = "https://api.mysubway.in";
export const CF_APPROVAL_HOSTNAME = "https://api.mysubway.in";
export const FINANCE_HOSTNAME = "https://api.mysubway.in";
export const BD_LEAD_HOSTNAME = "https://api.mysubway.in";
export const REPORT_HOSTNAME = "https://reports.mysubway.in";
export const DOCUMENT_STORAGE_HOSTNAME = "https://api.mysubway.in";
export const FINANCE_V2_HOSTNAME = "https://api.mysubway.in";

// export const HOSTNAME = `http://localhost:5001`;
// export const INTRANETHOSTNAME = "http://localhost:5001"; // This should be the hostname of the central service
// export const INVOICE_TRACKING_HOSTNAME = "http://localhost:4000"; //This should be the hostname of the invoice tracking service
// export const FINANCE_HOSTNAME = "http://localhost:5005";
// export const CF_APPROVAL_HOSTNAME = "http://localhost:5006"; // HOSTNAME for subway-cf-approval-api
// export const BD_LEAD_HOSTNAME = "http://localhost:4001";
// export const DOCUMENT_STORAGE_HOSTNAME = "http://localhost:3002";
// export const FINANCE_V2_HOSTNAME = "http://localhost:5010"; 
